export default {
  CALL_HISTORY_METHOD: '@@router/CALL_HISTORY_METHOD',
  LOCATION_CHANGE:     '@@router/LOCATION_CHANGE'
};
